import React from 'react';
import { ReactComponent as CompletedIcon } from 'images/completedIcon.svg';
import { Hotkeys } from 'constants/Hotkeys';
import { Option } from '../Option/Option';
import { OptionTitle, TagCatcherThrowsWrapper } from './TagCatcherThrowsStyles';

interface IProps {
  onPressHotkeyCallback: () => void;
  onClickCallback: () => void;
  disabled?: boolean;
}

const TagCatcherThrows: React.FC<IProps> = ({ onPressHotkeyCallback, onClickCallback, disabled }) => {
  const handleOnPressCallback = (): void => {
    if (!disabled) {
      onPressHotkeyCallback();
    }
  };

  const handleOnClickCallback = (): void => {
    if (!disabled) {
      onClickCallback();
    }
  };

  const renderDisplayName = (): string | JSX.Element => {
    const displayName = 'Catcher throws';
    if (disabled) {
      return (
        <OptionTitle>
          Catcher throws <CompletedIcon />
        </OptionTitle>
      );
    }

    return displayName;
  };

  return (
    <TagCatcherThrowsWrapper>
      <Option
        displayName={renderDisplayName()}
        hotkeyCode={Hotkeys.CatcherThrow.Option.keyCode}
        hotkeyDisplay={Hotkeys.CatcherThrow.Option.hotkeyDisplay}
        value=''
        onPressHotkeyCallback={handleOnPressCallback}
        onClickCallBack={handleOnClickCallback}
        data-test='CatcherThrows-0'
      />
    </TagCatcherThrowsWrapper>
  );
};

export default TagCatcherThrows;
